package io.horion.cv.models

import io.horion.cv.api.datasource.cv.Model
import io.horion.cv.api.datasource.motivation.ModelLetter


object CoverLetterData {
    val letters = mapOf(
        ModelLetter.SIMPLE.name to "letterSimple.webp",
        ModelLetter.PROFESSIONAL.name to "letterProfessional.webp",
        ModelLetter.FRENCH.name to "letterModerne.webp",
        ModelLetter.MODERN.name to "letterSimple.webp",
        ModelLetter.ADVANCE.name to "letterAdvance.webp",
        ModelLetter.ENGLISH.name to "letterSimple.webp",
    )
}